'use strict';

var _ = require('lodash');
var ChartDashboardRankingsController = function ChartDashboardRankingsController($scope, $q, formatterService, chartDashboardRankingsDataService, BrushSelectionFilter) {
  $scope.ranking = {
    name: 'MARKET'
  };
  $scope.brushSelections = {};
  $scope.isChartVisible = true;
  $scope.isLoadFactorMetric = function () {
    return $scope.screenState.selectedMetric.id === 'loadFactor';
  };
  function getMarketPosSelection(brush) {
    brush = brush || $scope.brushSelections;
    var marketData = brush.market;
    var posData = brush.pos;
    var market = marketData ? marketData.over.concat(marketData.under).sort() : [];
    var pos = $scope.isLoadFactorMetric() ? null : posData ? posData.over.concat(posData.under).sort() : [];
    return {
      market: market,
      pos: pos
    };
  }
  $scope.updateChartData = function (data) {
    var selectedItems = getMarketPosSelection();
    if (!_.isEmpty(selectedItems.market)) {
      data.filter.market.over = _.intersection(data.filter.market.over, selectedItems.market);
      data.filter.market.under = _.intersection(data.filter.market.under, selectedItems.market);
    }
    if (!_.isEmpty(selectedItems.pos)) {
      data.filter.pos.over = _.intersection(data.filter.pos.over, selectedItems.pos);
      data.filter.pos.under = _.intersection(data.filter.pos.under, selectedItems.pos);
    }
    $scope.data = data;
    $scope.brushSelections = data.filter;
    $scope.$broadcast('dashboard:ranking:brush-filter');
  };
  $scope.$on('dashboard:ranking:brush-filter', function () {
    var brushFilter = new BrushSelectionFilter('markets-and-poses', [getMarketPosSelection()]);
    $scope.$emit('brush-filter:filterApplied', brushFilter);
  });
  $scope.$watch('brushSelections', function (newBrush, oldBrush) {
    if (!_.isEqual(getMarketPosSelection(newBrush), getMarketPosSelection(oldBrush))) {
      $scope.reloadChart();
    }
  }, true);
  $scope.resetChartData = function () {
    $scope.updateChartData({
      market: {
        overPerformingData: [],
        underPerformingData: []
      },
      pos: {
        overPerformingData: [],
        underPerformingData: []
      },
      filter: {
        market: {
          over: [],
          under: []
        },
        pos: {
          over: [],
          under: []
        }
      }
    });
  };
  function multipleMarketsSelected() {
    var marketData = $scope.data.market;
    return _.size(marketData.overPerformingData) + _.size(marketData.underPerformingData) > 1;
  }
  $scope.reloadChart = function (adjustPanelVisibility) {
    chartDashboardRankingsDataService.getData($scope.screenState, getMarketPosSelection()).then($scope.updateChartData, $scope.resetChartData).then(function () {
      if (adjustPanelVisibility) {
        $scope.setChartVisibility(multipleMarketsSelected());
      }
    });
  };
  $scope.isRankingVisible = function (ranking) {
    return $scope.isChartVisible && $scope.ranking.name === ranking;
  };
  $scope.getChartLabel = function (type) {
    var label = type === 'over' ? 'Overperforming' : 'Underperforming';
    if ($scope.screenState.dataRepresentation === 'percentage') {
      return label + ' %';
    }
    return label;
  };
};
ChartDashboardRankingsController.$inject = ['$scope', '$q', 'FormatterService', 'ChartDashboardRankingsDataService', 'BrushSelectionFilterFactory'];
module.exports = ChartDashboardRankingsController;